import type { PseudoProject, CreatePseudoProjectRequest, UpdatePseudoProjectRequest } from '../types/todo.js';

const BASE_URL = '/api/pseudo-projects';

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: { message: response.statusText } }));
    throw new Error(body.error?.message ?? `Request failed: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export async function getPseudoProjects(): Promise<PseudoProject[]> {
  return fetchJson<PseudoProject[]>(BASE_URL);
}

export async function getPseudoProject(id: number): Promise<PseudoProject> {
  return fetchJson<PseudoProject>(`${BASE_URL}/${id}`);
}

export async function createPseudoProject(data: CreatePseudoProjectRequest): Promise<PseudoProject> {
  return fetchJson<PseudoProject>(BASE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

export async function updatePseudoProject(id: number, data: UpdatePseudoProjectRequest): Promise<PseudoProject> {
  return fetchJson<PseudoProject>(`${BASE_URL}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

export async function deletePseudoProject(id: number): Promise<void> {
  const response = await fetch(`${BASE_URL}/${id}`, { method: 'DELETE' });
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: { message: response.statusText } }));
    throw new Error(body.error?.message ?? `Request failed: ${response.status}`);
  }
}
